import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import { selectUserIsIdentified } from 'core/selectors/user';
import { scrollToElement } from 'core/utils/helpers/scrollToElement';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import {
  useTriggerInstoreDetailsIsViewedGaEvent,
} from 'core/modules/Instore2/hooks/useTriggerInstoreDetailsIsViewedGaEvent';
import { ME_PAGE_INSTORE } from 'core/modules/Instore2/utils/constants';
import WithLinkedCardsView from './components/WithLinkedCardsView';
import AnonymousView from './components/AnonymousView';
import WithoutAnyCardsView from './components/WithoutAnyCardsView';
import WithoutLinkedCardsView from './components/WithoutLinkedCardsView';

import './MeInstoreOffer.scss';

function MeInstoreOffer({ offer }) {
  const location = useLocation();
  const isUserIdentified = useSelector(selectUserIsIdentified);
  const [isOpenByDefault, setIsOpenByDefault] = useState(false);

  const goToOffer = () => {
    scrollToElement(location.hash, 500, 20);
    setIsOpenByDefault(true);
  };

  useTriggerInstoreDetailsIsViewedGaEvent(offer, ME_PAGE_INSTORE);

  useEffect(() => {
    if (location.hash === '#instore') {
      document.readyState === 'complete'
        ? goToOffer()
        : window.addEventListener('load', () => { setTimeout(goToOffer, 1000); });
    }
  }, [location.hash]);

  if (isEmpty(offer)) {
    return null;
  }

  const { hasEligibleCards, hasLinkedCards } = offer;

  if (!isUserIdentified) {
    return <AnonymousView offer={offer} isOpenByDefault={isOpenByDefault} />;
  }

  if (hasLinkedCards) {
    return <WithLinkedCardsView offer={offer} isOpenByDefault={isOpenByDefault} />;
  }

  if (hasEligibleCards && !hasLinkedCards) {
    return <WithoutLinkedCardsView offer={offer} isOpenByDefault={isOpenByDefault} />;
  }

  return <WithoutAnyCardsView offer={offer} isOpenByDefault={isOpenByDefault} />;
}

export default (props) => <ComponentErrorBoundary><MeInstoreOffer {...props} /></ComponentErrorBoundary>;
